import { useAsyncValue } from "react-router-dom";

import { Dashboard as TransactionsDashboard } from "@counselpro/counselkit";

export default function ResolvedView() {
  const transactions = useAsyncValue();

  return <TransactionsDashboard data={transactions} />;
}
